import { useCallback } from "react";
import { reportingService } from "services";
import { MonthlyCaTable } from "./MonthlyCaTable";
export const ChiffreAffaireParAgence = () => {
  const load = useCallback((params: Record<string, any>) => reportingService.findCaMensuelByAgences(params), []);
  return <MonthlyCaTable label="Agence" load={load} />;
};
